<template>
  <v-chip
    v-if="label && cor"
    small
    label
    text-color="white"
    :color="cor"
  >
    {{ label }}
  </v-chip>
</template>

<script>
import { labelCentroFuncional, corCentroFuncional } from '@/common/helpers/centroFuncional'

export default {
  name: 'CentroFuncionalBadge',

  props: {
    valor: {
      type: String,
      required: false,
      default: null
    },
    areaTecnica: {
      type: String,
      required: false,
      default: null
    }
  },

  computed: {
    label() {
      return labelCentroFuncional(this.valor, this.areaTecnica)
    },

    cor() {
      return corCentroFuncional(this.valor)
    }
  }
}
</script>
